export default {
  /**
   * Set List
   *
   * @param state
   * @param items
   */
  setEmployeeMonthlyAttendanceExportList(state, items) {
    console.log("Items: ", items);
    state.items = items;
  },

  /**
   * Set List Pagination.
   *
   * @param state
   * @param pagination
   */
  setEmployeeMonthlyAttendanceExportListPagination(state, pagination) {
    console.log("Pagination: ", pagination);
    state.pagination = pagination;
  },

  /**
   * Set List Page.
   *
   * @param state
   * @param page
   */
  setEmployeeMonthlyAttendanceExportListPage(state, page) {
    console.log("Page: ", page);
    state.pagination.current_page = page;
  },

  /**
   * Set date filter.
   *
   * @param state
   * @param date
   */
  setEmployeeMonthlyAttendanceExportDateFilter(state, date) {
    console.log("Date: ", date);
    state.filter.date = date;
  },
};
